import { useNavigate } from 'react-router';
import Zoom from '@mui/material/Zoom';
import { useTranslation } from '@/locales';
import RedirectIcon from '@/assets/icons/redirect-icon.svg?react';
import { useTracking } from '@/hooks/useTracking';
import { useBreakpointsCtx } from '@/providers/BreakpointsProvider/BreakpointsContext.hooks';
import Tooltip from '@/components/atoms/Tooltip/Tooltip';
import { StyledInfoIcon } from '@/components/StyledSharedComponents/StyledIcons';
import { StyledAgioH1 } from '@/components/StyledSharedComponents/StyledTypography';
import {
  StyledHeader,
  StyledPermittedToolbar,
  StyledTitleWithTooltipWrapper,
} from '@/layouts/MainLayout/components/HeaderWithNavigation/components/Headers/SharedHeaders.styled';
import { StyledButton } from './RiskRimulatorHeader.styled';
import { ERoutes } from '@/types/routes';

export const RiskSimulatorHeaderPermitted = () => {
  const { t } = useTranslation('riskSimulator');
  const navigate = useNavigate();
  const { trackEvent } = useTracking();
  const { isDesktop } = useBreakpointsCtx();

  const handleDocumentationClick = () => {
    trackEvent('Risk-Monitoring Whitepaper Clicked', {});
    navigate(`${ERoutes.DOCUMENTATION}/modeling/risk-simulator`);
  };

  return (
    <StyledHeader position="static" isDesktop={isDesktop}>
      <StyledPermittedToolbar>
        <StyledTitleWithTooltipWrapper>
          <StyledAgioH1
            noWrap
            color="customSecondary.primary.DEFAULT"
            data-testid="risk-simulator-header-title"
          >
            {t('risk-simulator.header.title')}
          </StyledAgioH1>
          <Tooltip arrow title={t('risk-simulator.header.tooltip')}>
            <div>
              <StyledInfoIcon />
            </div>
          </Tooltip>
        </StyledTitleWithTooltipWrapper>

        <div>
          <Tooltip
            arrow
            slots={{ transition: Zoom }}
            placement="left"
            title={t('risk-simulator.header.documentation-btn.tooltip')}
          >
            <div>
              <StyledButton
                variant="outlined"
                color="tertiary"
                skipTypography
                onClick={handleDocumentationClick}
              >
                <RedirectIcon width="15px" height="15px" />
                {t('risk-simulator.header.documentation-btn.content')}
              </StyledButton>
            </div>
          </Tooltip>
        </div>
      </StyledPermittedToolbar>
    </StyledHeader>
  );
};
